<template lang="pug">
.refund-data-container(@click="expand = !expand")
  .refund-data
    .menu-icon-refund.relative(@click.stop="")
      img(:src="require('@/assets/menu.svg')" alt="menu" @click="showMenu")
      transition(name="opacity-bottom")
        shMenuRefund(v-if="showedMenu" @sendNotification="sendNotification" @openNotificationHistory="openNotificationHistory" :index="indexMenu")

    .refund-number
      span.material-symbols-outlined(:class="`color-${data.brand}`") currency_exchange
      span.tag(:class="`bg-${data.brand}`") {{ data.refund }}

    .refund-order(v-if="!history")
      span.material-symbols-outlined(:class="`color-${data.brand}`") shopping_cart
      span.tag(:class="`bg-${data.brand}`") {{ data.order }}

    .refund-status(v-if="!history")
      .tag(:style="styleStatus") {{ translateStatus(data.status) }}

    .refund-value(v-if="!history") {{ money(data.value) }}

    .refund-method(v-if="!history && data.method")
      shTagDescription(:description="capitalize(data.method)")
        .no-select {{ cutValue(capitalize(data.method)) }}

    .refund-phone(v-if="!history && data.phones && data.phones.length") {{ data.phones[0] }}

    .refund-date(v-if="!history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

    .refund-transaction(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}

    .refund-date(v-if="history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

    .refund-pack-icon(v-if="showPackIcon" :class="{ 'is-pack-pending': !data.packReceived }" @click.stop="")
      shActionButton(
        :action="togglePackReceived"
        :params="[data.refund]"
        icon="inventory_2"
        :text="data.packReceived ? 'Deshacer recibido' : 'Recibir paquete'"
        :textRunning="data.packReceived ? 'Deshaciendo' : 'Recibiendo'"
        :normalColor="true"
        :textConfirmation="data.packReceived ? '¿Desea deshacer el paquete recibido?' : '¿Desea recibir el paquete?'"
      )

  .refund-actions-container(@click.stop="")
    .refund-actions
      .buttons-actions(v-if="data.status === 'created'")
        shActionButton(:action="decline" :params="[data.refund]" text="Declinar" textRunning="Declinando")
        shActionButton(:action="approve" :params="[data.refund]" text="Aprobar" textRunning="Aprobando")

      .buttons-actions(v-if="data.status === 'approved'")
        shActionButton(:action="disapprove" :params="[data.refund]" text="Desaprobar" textRunning="Desaprobando")
        shActionButton(:action="refund" :params="[data.refund]" text="Reembolsar" textRunning="Reembolsando")

  NotificationHistoryModal(
    :show="notificationHistoryModal.show"
    title="Historial de notificaciones"
    codeLabel="Reembolso"
    :code="notificationHistoryModal.refund"
    :entries="notificationHistoryEntries"
    @close="closeNotificationHistory"
  )

  transition(name="slide-fade")
    shForm.list-refund(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")

  transition(name="slide-fade")
    shHistory.list-refund(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import shActionButton from '@/components/elements/ActionButton'
import shMenuRefund from './MenuRefund'
import NotificationHistoryModal from '@/components/elements/NotificationHistoryModal.vue'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import gqlRefund from '@/graphql/refund'
import gql from '@my/graphql'
import modals from '@my/store/modals'

export default {
  name: 'Refund',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory, shActionButton, shMenuRefund, NotificationHistoryModal },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false,
      indexMenu: -1,
      notificationHistoryModal: {
        show: false,
        refund: ''
      }
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    async decline (refund) {
      const mutation = gqlRefund.DECLINE
      if (!refund) return
      const response = await gql.mutate(mutation, { refund, sendNotifications: false })
      if (response) modals.showMessage({ message: `Se declinó el reembolso ${refund} correctamente` })
    },

    async approve (refund) {
      const mutation = gqlRefund.APPROVE
      if (!refund) return
      const response = await gql.mutate(mutation, { refund, sendNotifications: false })
      if (response) modals.showMessage({ message: `Se aprobó el reembolso ${refund} correctamente` })
    },

    async disapprove (refund) {
      const mutation = gqlRefund.DISAPPROVE
      if (!refund) return
      const response = await gql.mutate(mutation, { refund, sendNotifications: false })
      if (response) modals.showMessage({ message: `Se desaprobó el reembolso ${refund} correctamente` })
    },

    async refund (refund) {
      const mutation = gqlRefund.REFUND
      if (!refund) return
      const response = await gql.mutate(mutation, { refund })
      if (response) modals.showMessage({ message: `El reembolso ${refund} ha sido efectuado` })
    },

    async sendNotification () {
      const refund = this.data && this.data.refund
      if (!refund) return
      const response = await gql.mutate(gqlRefund.SEND_NOTIFICATION, { refund })
      if (response) modals.showMessage({ message: `Se envió la notificación del reembolso ${refund}` })
    },

    openNotificationHistory () {
      this.notificationHistoryModal.refund = this.data && this.data.refund
      this.notificationHistoryModal.show = true
    },

    closeNotificationHistory () {
      this.notificationHistoryModal.show = false
    },

    async showMenu () {
      if (this.showedMenu) {
        this.hideMenu()
        return
      }

      if (this.indexMenu !== -1) {
        this.$store.commit('showMenu', this.indexMenu)
        return
      }

      this.indexMenu = await this.$store.dispatch('setMenu')
    },

    hideMenu () {
      this.$store.commit('hideMenu', this.indexMenu)
    },

    async receivePackage (refund) {
      const mutation = gqlRefund.RECEIVE_PACKAGE
      if (!refund) return
      const response = await gql.mutate(mutation, { refund })
      if (response) modals.showMessage({ message: `Paquete recibido para el reembolso ${refund}` })
    },

    async unreceivePackage (refund) {
      const mutation = gqlRefund.UNRECEIVE_PACKAGE
      if (!refund) return
      const response = await gql.mutate(mutation, { refund })
      if (response) modals.showMessage({ message: `Se deshizo el recibido del paquete para el reembolso ${refund}` })
    },

    async togglePackReceived (refund) {
      if (this.data.packReceived) return this.unreceivePackage(refund)
      return this.receivePackage(refund)
    },

    cutValue (value) {
      const maxLength = 8
      return value.slice(0, maxLength) + (value.length > maxLength ? '...' : '')
    },

    translateStatus (status) {
      const map = {
        created: 'Creado',
        approved: 'Aprobado',
        refunded: 'Reembolsado',
        declined: 'Declinado'
      }
      return map[status] || status
    },

    translateType (type) {
      const map = {
        refund: 'Reembolso',
        change: 'Cambio',
        manual: 'Manual'
      }
      return map[type] || type
    }
  },

  computed: {
    showPackIcon () {
      return !this.history && this.data.status !== 'declined' && this.data.status !== 'refunded'
    },

    showedMenu () {
      return this.$store.state.interface.menus[this.indexMenu]
    },

    notificationHistoryEntries () {
      return (this.data && this.data.notifications && this.data.notifications.history) || []
    },

    styleStatus () {
      const colors = {
        created: { background: '#e9e9e7', color: '#616161' },
        approved: { background: '#A5AA72', color: '#ffffff' },
        refunded: { background: '#56AEFF', color: '#ffffff' },
        declined: { background: '#AA7572', color: '#ffffff' }
      }
      const c = colors[this.data.status]
      if (!c) return ''
      return `background: ${c.background}; color: ${c.color}`
    }
  }
}
</script>

<style lang="stylus">
.refund-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.refund-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis calc(100% - 3rem)
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.refund-actions-container
  display flex
  align-items center
  gap 1.5rem
  padding 0 1rem

.refund-actions
  display flex
  align-items center
  gap 1em

.menu-icon-refund img
  height 1em
  cursor pointer
  position relative
  top .1em

.refund-number, .refund-order
  display flex
  align-items center
  gap .5em

.refund-method
  display flex
  flex-basis 10rem

.refund-method img
  height 1.6rem
  display block

.list-refund
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .refund-data
    flex-basis calc(100% - 16rem - 5rem)
    column-gap 0
    row-gap 1em

  .refund-number
    width 10em
  .refund-order
    width 8em
  .refund-status
    width 8em
  .refund-type
    width 7em
  .refund-value
    width 8em
  .refund-method
    width 5em
  .refund-phone
    width 8em
  .refund-date
    width 10em
  .refund-transaction
    width 8em
  .refund-actions
    width 16em

  .refund-pack-icon
    margin-left auto
    opacity 1

  .refund-pack-icon.is-pack-pending
    opacity 0.4

  .refund-actions-container
    padding 0
</style>



// WEBPACK FOOTER //
// src/components/pages/refund/Refund.vue